<template lang="pug">
k-page.preview( :class='postData.release_type' :key='postData.id' )
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  k-hero
  w-go-down
  k-main( :title='title' )
    media-info-icons( :post='postData' )

    //- TODO: strips for related, series
    section.description( v-html='content' )
    b-btn.float-right(
      v-if=`postData.full_content
            && canWatchNow( postData.full_content )`
      variant='primary'
      :to='postData.full_content.path'
      size='lg'
    ) {{ sayAction( postData.full_content )}} now
    section.subscriptions( v-else )
      subscription-menu( :target='postData.path' )
        | Select one of the subscription plans to see the full content.
  .bottom-spacer
</template>

<script lang="js">
import mediaActions from '@/mixins/media-actions'
import routeEvents from '@/lib/route-events'
import DMainImage from '@/displays/d-main-image'
import KPage from '@/blocks/k-page'
import KHero from '@/blocks/k-hero'
import KMain from '@/blocks/k-main'
import WGoDown from '@/widgets/w-go-down'
import SubscriptionMenu from '@/components/subscription-menu'
import MediaInfoIcons from '@/components/media-info-icons'
import { Post } from '@/mixins'

export default {
  name: 'PreviewReleasePage',
  mixins: [ mediaActions, Post ],
  components: {
    DMainImage,
    KPage,
    KHero,
    KMain,
    WGoDown,
    SubscriptionMenu,
    MediaInfoIcons,
  },
  props: [],
  data() {
    return {
      storedPost: {
        stats: {},
        my_xp: {}
      },
      prev: 0,
      next: 0,
      wideMode: false
    }
  },
  created() {},
  beforeRouteUpdate: routeEvents.toPreviewRelease,
  mounted() {
    window.setTimeout(() => {
      if ( this.promos && this.promos.length ) {
        this.setHero({
          name: 'video-preview',
          data: {
            content: this.promos[0]
          }
        })
      }
    }, 500 )
  },
  methods: {
  },
  computed: {
    fullContent() {
      return this.postData.full_content
    },
    promos() {
      return [{
        id: this.postData.id,
        excerpt: { rendered: this.content }
      }].concat( this.postData.promo_reel || [])
    },
    episodes() {
      return this.postData.releases || []
    },
    content() {
      return this.postData.content ? this.postData.content.rendered
         : this.postData.caption ? this.postData.caption.rendered : ''
    },
    classes() {
      return { small: !!this.promos.length } 
    }
  },
  watch: {
    $route( to, from ) {
      if ( this.promos && this.promos.length ) {
        this.setHero({
          name: 'video-preview',
          data: {
            content: this.promos[0],
            series: this.promos // TODO: verify
          }
        })
      }
    },
  }
}
</script>

<style lang="scss">
.preview-release {

}
</style>
